import styled from 'styled-components';

import StorebrandLogo from '@/assets/logo/storebrand.svg';

export const StyledStorebrandLogo = styled(StorebrandLogo)`
  height: 28px;
`;
